import { render } from "./rating.vue?vue&type=template&id=3c819446&scoped=true"
import script from "./rating.vue?vue&type=script&lang=js"
export * from "./rating.vue?vue&type=script&lang=js"

import "./rating.vue?vue&type=style&index=0&id=3c819446&scoped=true&lang=css"

import exportComponent from "/var/www/worldchatbox/node_build/worldchatbox_dev2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c819446"]])

export default __exports__